export const createAmericanAirlinesLoginUrl = (culture: string) => {
	const encodedUrl = encodeURIComponent(`${window.location.origin}/Login/AmericanAirlines`);
	return `${window.JetSmart?.AmericanAirlinesSettings?.LoginAddress}?locale=${culture}&target=${encodedUrl}`;
};

export const createAmericanAirlinesAccountSummaryUrl = (culture: string) => {
	const [language, country] = culture.split("-");
	const locale = `${language}_${country.toUpperCase()}`;
	return `${window.JetSmart?.AmericanAirlinesSettings?.AccountSummaryAddress}?locale=${locale}`;
};
